import { orderings } from '@/utils/orderings'
import FiltersCollection from '@/domain/FiltersCollection'

export const loaded = state => {
  return state.manifest.loaded && state.profile.loaded
}
export const items = (state, getters) => {
  if (getters.loaded) {
    const items = new FiltersCollection(state.filters).filter(state.profile.items)
      .sort(orderings[state.filters.ordering])
    return items
  }
  return []
}



// WEBPACK FOOTER //
// ./src/store/destiny/getters.js